<template>
  <div class="evolucao">
    <kpi-view-tabs current="kpi-evolucao-performance" />

    <b-card
      no-body
      class="evolucao__card"
    >
      <futuro-loader
        v-if="carregando"
        block
        size="88"
        show-label
        label="Abrindo o painel de performance..."
        class="evolucao__loader"
      />

      <iframe
        :src="fonte"
        class="evolucao__frame"
        :class="{ 'evolucao__frame--oculto': carregando }"
        title="Evolução de performance"
        frameborder="0"
        allowfullscreen
        @load="carregando = false"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import FuturoLoader from '@/modules/shared/components/FuturoLoader.vue'
import KpiViewTabs from '../components/KpiViewTabs.vue'

/**
 * Evolução de Performance — o painel do Looker Studio, na moldura certa.
 *
 * O RELATÓRIO CONTINUA SENDO DO BI, DE PROPÓSITO
 *
 * §34 do briefing: "A Evolução de Performance tende a ser mantida ou
 * reconstruída como painel de BI, por ser mais adequada à customização
 * analítica e por evitar aumento de complexidade no Faturômetro nativo". §39
 * repete como direção técnica. Então o iframe fica, e o conteúdo dele — os
 * benchmarks, as projeções, os recordes do §35 — é trabalho do time de BI, não
 * desta tela.
 *
 * O QUE ERA DAQUI, E ESTAVA QUEBRADO
 *
 * §35 lista, entre os problemas, "conteúdo sem ocupar a tela inteira" e
 * "comportamento quebrado em diferentes níveis de zoom". Os dois vinham do
 * mesmo lugar: `height="650px"` cravado. Num monitor grande sobrava tela vazia
 * embaixo; com zoom o painel ficava espremido numa faixa.
 *
 * Agora a altura é o que sobra da viewport (`100vh` menos o cabeçalho do
 * Oráculo), com um piso para o painel não virar uma fresta em tela baixa. Zoom
 * não quebra porque não há mais medida em pixel fixo.
 *
 * O loader existe porque o Looker leva segundos para pintar e a tela ficava
 * branca no meio-tempo — o que se lê como "quebrou", não como "carregando".
 */
const FONTE = 'https://lookerstudio.google.com/embed/reporting'
  + '/3795b863-8109-4e07-b338-8118d295c570/page/p_lqnjpg35kd'

export default {
  name: 'PerformanceEvolution',
  components: { BCard, FuturoLoader, KpiViewTabs },
  data() {
    return {
      carregando: true,
      fonte: FONTE,
    }
  },
}
</script>

<style lang="scss" scoped>
.evolucao__card {
  overflow: hidden;
}

.evolucao__frame {
  display: block;
  width: 100%;
  /* O que sobra da janela depois do cabeçalho e das abas. Sem pixel fixo, o
     zoom deixa de quebrar o enquadramento. */
  height: calc(100vh - 15rem);
  /* Piso: em tela baixa o painel não pode virar uma fresta. */
  min-height: 520px;
  border: 0;
}

.evolucao__frame--oculto {
  /* Escondido, não desmontado: o iframe precisa continuar carregando para o
     evento de load chegar e o loader sair. */
  visibility: hidden;
  height: 0;
  min-height: 0;
}

.evolucao__loader {
  padding: 5rem 0;
}

@media (max-width: 767.98px) {
  .evolucao__frame {
    height: calc(100vh - 12rem);
    min-height: 420px;
  }
}
</style>
